export default __webpack_public_path__ + "static/media/Nike.6ce336b3.png";